import { render } from "./ReturnRefund.vue?vue&type=template&id=28dc6b96&scoped=true"
import script from "./ReturnRefund.vue?vue&type=script&lang=js"
export * from "./ReturnRefund.vue?vue&type=script&lang=js"

import "./ReturnRefund.vue?vue&type=style&index=0&id=28dc6b96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28dc6b96"

export default script